const DATA = {
  heroSubNav: [
    {
      title: 'Backers',
      link: '#backers',
    },
    {
      title: 'Vision',
      link: '#vision',
    },
    {
      title: 'Roadmap',
      link: '#roadmap',
    },
    {
      title: 'News',
      link: '#news',
    },
  ],
  subnav: [
    {
      title: 'The Hub',
      link: '#hub',
    },
    {
      title: 'Ecosystem',
      link: '#ecosystem',
    },
    {
      title: 'Team',
      link: '#team',
    },
  ],
  appSubNav: [
    {
      title: 'Watch2Earn',
      link: '#watch',
    },
    {
      title: 'Trade',
      link: '#trade',
    },
    {
      title: 'Leaderboard',
      link: '#leaderboard',
    },
    {
      title: 'Points',
      link: '#points',
    },
    {
      title: 'FAQs',
      link: '#faqs',
    },
  ],
  tokenSubNav: [
    {
      title: 'Transparency',
      link: '#transparency',
    },
    {
      title: 'Stats',
      link: '#stats',
    },
    {
      title: 'Utility',
      link: '#utility',
    },
    {
      title: 'Tokenomics',
      link: '#tokenomics',
    },
  ],
}

export default DATA
